import ContentItem from '../api/content/ContentItem';
import { Emitter } from '../common/interfaces';
import {
  ApiEvents,
  ItemSource,
  SourcesSetEvent
} from '@kollective-frontend/ksdk-api';
import contentItemsToItemSources from '../util/contentItemsToItemSources';

const dedupItemSources = (items: ItemSource[]): ItemSource[] => {
  const out: Map<string, ItemSource> = items.reduce((acc, n) => {
    if (acc.has(n.src)) {
      return acc;
    } else {
      acc.set(n.src, n);
      return acc;
    }
  }, new Map());

  return Array.from(out.values());
};

export default function notifySourcesReady(
  eventEmitter: Emitter,
  opts: {
    reason: string;
    sources: ContentItem[];
    sourcesSet?: ContentItem[];
    kollectiveSources?: ContentItem[];
  }
): void {
  const type = ApiEvents.SOURCES_READY;

  const { reason } = opts;
  const data: SourcesSetEvent = {
    reason,
    publishedSources: dedupItemSources(contentItemsToItemSources(opts.sources)),
    sourcesSet:
      opts.sourcesSet &&
      dedupItemSources(contentItemsToItemSources(opts.sourcesSet)),
    kollectiveSources:
      opts.kollectiveSources &&
      dedupItemSources(contentItemsToItemSources(opts.kollectiveSources))
  };
  const event = { type, data };

  eventEmitter.emit(type, event);
}
